import { useState } from 'react';
import { useTheme } from '../../styles/ThemeContext';

/**
 * Modal when adding a product with type "E" that is already in the unit.
 * User can enter quantity to add to existing, or cancel.
 */
export function EProductQtyModal({ isOpen, onClose, onConfirm, product, existingProd }) {
  const [addQty, setAddQty] = useState('1');
  const { theme } = useTheme();
  const c = theme.colors;

  if (!isOpen) return null;

  const productName = product?.product?.product || product?.product || 'Product';
  const existingQty = existingProd?.qty ?? 0;

  const handleConfirm = () => {
    const qty = parseInt(addQty, 10) || 0;
    onConfirm(qty);
    setAddQty('1');
  };

  const handleClose = () => {
    setAddQty('1');
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: c.overlay,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: c.bg,
          border: '1px solid ' + c.border,
          borderRadius: 6,
          maxWidth: 420,
          width: '90%',
          boxShadow: '0 16px 32px ' + c.shadow
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '20px 20px 16px' }}>
          <div style={{ fontSize: 18, marginBottom: 12, fontWeight: 600, color: c.text }}>
            ✓ Product already added
          </div>
          <p style={{ margin: '0 0 16px 0', fontSize: 13, lineHeight: 1.6, color: c.textSecondary }}>
            <strong style={{ color: c.text }}>{productName}</strong> is already in this unit (current: {existingQty}).
            Enter the quantity to add:
          </p>
          <input
            type="number"
            min="1"
            value={addQty}
            onChange={(e) => setAddQty(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
            style={{
              width: '100%',
              padding: '10px 12px',
              fontSize: 14,
              border: '1px solid ' + c.border,
              borderRadius: 4,
              background: c.bgInput,
              color: c.text
            }}
            autoFocus
          />
        </div>
        <div style={{ borderTop: '1px solid ' + c.border, padding: '12px 20px', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={handleClose} style={theme.btnG}>
            Cancel
          </button>
          <button onClick={handleConfirm} style={{ ...theme.btnP, fontWeight: 600 }}>
            Add
          </button>
        </div>
      </div>
    </div>
  );
}
